import {useCallback} from 'react';

import {
  AnalyticsProvider,
  ClientProvider,
  WidgetAPI,
  WidgetProvider,
} from '@stripe-internal/conversations-ui';

import {FileUploadProvider} from './FileUploadProvider';
import {useApp, useConfig} from '../hooks/appHooks';

export function ConversationsUIProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  const app = useApp();
  const config = useConfig();

  const actionHandler = useCallback<WidgetAPI['requestAction']>(
    (action, opts) => app.requestAction({action, ...opts}),
    [app],
  );

  return (
    <AnalyticsProvider analytics={app.analytics}>
      <ClientProvider value={app.client}>
        <FileUploadProvider>
          <WidgetProvider
            initialVisibility={config.initialVisibility}
            audience={config.audience}
            entryPoint={config.entryPoint}
            parentOrigin={config.parentOrigin}
            // TODO: will need to update lingering references to widget.requestAction
            // to not reference the widget.
            // That and a few dot_com specific widget visibility references
            // are what's remaining, before we could get rid of this provider
            // for the extracted assistant
            actionHandler={actionHandler}
            // note we specifically do not pass a parentMessageBus to the
            // widget provider as we want all message handling done by the
            // assistant now
          >
            {children}
          </WidgetProvider>
        </FileUploadProvider>
      </ClientProvider>
    </AnalyticsProvider>
  );
}
